<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">OSBOD Actieve Werknemers</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
			<v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details></v-text-field>
		</v-card-title>

		<v-data-table :headers="headers" :items="data" :search="search" :loading="loading">
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<v-btn depressed class="ml-2" @click="setEmployeeCohort()" color="inverted">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>Add EmployeeCohort
					</v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.action="{ item }">
				<v-icon @click="handleClick(item.id)">mdi-account-edit</v-icon>
			</template>
		</v-data-table>
	</v-card>
</template>
 
 <script>
import Axios from "axios";
//import _ from "lodash";
import { API_ROOT } from "../../config";
console.log(API_ROOT.osbod_salary);
const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "employee_cohorts",
	data() {
		return {
			//user: localStorage.getItem("user"),
			search: "",
			headers: [
				{
					text: "",
					align: "center",
					sortable: false,
					value: "action"
				},
				{ text: "Schoolyear", value: "tbl_sys_schoolyear.name" },
				{ text: "Function", value: "tbl_employee.tbl_sys_function.name" },
				{ text: "Government ID", value: "tbl_employee.government_id" },
				{ text: "Firstname", value: "tbl_employee.firstname" },
				{ text: "Maidenname", value: "tbl_employee.maidenname" },
				{ text: "Lastname", value: "tbl_employee.surname" },
				{ text: "Birthdate", value: "tbl_employee.birthdate" },
				{ text: "Mobiel", value: "tbl_employee.tel_mobile" },
				{ text: "E-mail", value: "tbl_employee.email" },
				{ text: "E-mail OSBOD", value: "tbl_employee.osbod_email" },


			],
			// semesters: [],
			// studies: [],
			// subjects: [],
			// subjecttypes: [],
			// selected_subject: null,
			// selected_kwalificatie: null,
			// selected_deelkwalificatie: null,
			// selected_semester: null,
			// schoolyear: [],
			// selected_schoolyear: null,
			data: [],
			// banktypes: [],
			isEmpty: false,
			loading: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 15
		};
	},
	created: function() {
		// this.getBanktypes();
		this.getEmployeeCohort();
	},
	watch: {
		// selected_kwalificatie: function(value) {
		// 	this.getStudySubjecttype(value);
		// 	console.log(value);
		// }
	},
	computed: {
		// school() {
		// 	return this.$store.getters.getSchool;
		// }
	},
	methods: {
		handleClick(id) {
			this.$router.push({
				path: "/schooladmin/employee_cohort/update/" + id
			});
		},
		setEmployeeCohort: function() {
			this.$router.push({
				path: "/schooladmin/employee_cohort/new"
			});
		},
		getEmployeeCohort: function() {
			var self = this;
			this.loading = true;
			ax.get("/employee_cohort/all").then(function(response) {
					// console.log(response.data);
				self.data = response.data;
				console.log("EmployeeCohort fetched...");
				console.log(response.data);
				self.loading = false;
			});
		},
		// getBanktypes: function() {
		// 	var self = this;
		// 	ax.get("/banktype/all").then(function(response) {
		// 		console.log(response.data);
		// 		self.banktypes = response.data;
		// 	});
		// }
	}
};
</script>
 
 <!-- Add "slot-scoped" attribute to limit CSS to this component only -->
 <style slot-scoped>
</style>